export class LicenseReactivateSimulationResponsev2 {

    ReactivatePossible: boolean;
    ReactivateNotPossibleReason: string;

    InGraceReactivation: boolean;

    ProductName: string;
    ProductPrice: number;
    SetupPrice: number;
    YARDPrice: number;
    TotalPrice: number;
    Credit: number;
    Total: number;

    NextBillingDate: Date;

    TaxRate: number;
    TaxRateDisplay: string;
    ProductPriceTax: number;
    SetupPriceTax: number;
    YARDPriceTax: number;

    TotalPriceTax: number;
    TotalWithTax: number;

    State: string;


    public static FixDate(item: LicenseReactivateSimulationResponsev2) {
        item.NextBillingDate = new Date(item.NextBillingDate);
    }
}
